
(function () {
  const SELECT_EVENT = 'divano:variant:select';

  function readVariantManifest(scriptEl) {
    if (!scriptEl) return null;
    try {
      const data = JSON.parse(scriptEl.textContent || '{}');
      if (!Array.isArray(data.variants) || !Array.isArray(data.option_names)) {
        return null;
      }
      return { variants: data.variants, optionNames: data.option_names };
    } catch (err) {
      console.warn('[divano-variant-adapter] Failed to parse variant manifest:', err);
      return null;
    }
  }

  function readCurrentSelection(pickerRoot, optionNames) {
    const url = new URL(window.location.href);
    return optionNames.map((name) => {
      const handle = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      const fromUrl = url.searchParams.get(handle);
      if (fromUrl) return fromUrl;

      const child = pickerRoot.querySelector(
        `[data-param-key="${cssEscape(handle)}"]`
      );
      return child && child.dataset.selected ? child.dataset.selected : '';
    });
  }

  function resolveVariant(variants, tuple) {
    for (const v of variants) {
      const vOptions = v.options || [];
      if (vOptions.length !== tuple.length) continue;
      let match = true;
      for (let i = 0; i < tuple.length; i += 1) {
        if (!tuple[i] || tuple[i] !== vOptions[i]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function updateMasterFormInputs(variantId, pickerRoot) {
    const scope = pickerRoot && pickerRoot.closest('.shopify-section');
    if (scope) {
      const inputs = scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
      inputs.forEach((input) => {
        if (input.closest('product-card')) return;
        input.value = String(variantId);
      });
    }
    const url = new URL(window.location.href);
    if (variantId) {
      url.searchParams.set('variant', String(variantId));
    } else {
      url.searchParams.delete('variant');
    }
    if (url.href !== window.location.href) {
      window.history.replaceState({}, '', url.toString());
    }
  }

  function setAddToCartUnavailable(pickerRoot, unavailable) {
    const scope = pickerRoot && pickerRoot.closest('.shopify-section');
    if (!scope) return;
    const label = pickerRoot.dataset.unavailableText || '';
    scope.querySelectorAll('add-to-cart-component').forEach((container) => {
      if (container.closest('product-card')) return;
      const button = container.querySelector('button[name="add"]');
      const text = container.querySelector('.add-to-cart-text__content');
      if (unavailable) {
        if (container.dataset.divanoUnavailable === 'true') return;
        if (button && button.disabled) return;
        container.dataset.divanoUnavailable = 'true';
        if (text && label) {
          container.dataset.divanoLabelWas = text.innerHTML;
          text.textContent = label;
        }
        if (typeof container.disable === 'function') container.disable();
        else if (button) button.disabled = true;
      } else {
        if (container.dataset.divanoUnavailable !== 'true') return;
        delete container.dataset.divanoUnavailable;
        if (text && container.dataset.divanoLabelWas !== undefined) {
          text.innerHTML = container.dataset.divanoLabelWas;
          delete container.dataset.divanoLabelWas;
        }
        if (typeof container.enable === 'function') container.enable();
        else if (button) button.disabled = false;
      }
    });

    scope.querySelectorAll('.sticky-add-to-cart__button').forEach((button) => {
      const text = button.querySelector('.add-to-cart-text__content > span');
      if (unavailable) {
        if (button.dataset.divanoUnavailable === 'true') return;
        if (button.disabled) return;
        button.dataset.divanoUnavailable = 'true';
        if (text && label) {
          button.dataset.divanoLabelWas = text.innerHTML;
          text.textContent = label;
        }
        button.disabled = true;
      } else {
        if (button.dataset.divanoUnavailable !== 'true') return;
        delete button.dataset.divanoUnavailable;
        if (text && button.dataset.divanoLabelWas !== undefined) {
          text.innerHTML = button.dataset.divanoLabelWas;
          delete button.dataset.divanoLabelWas;
        }
        button.disabled = false;
      }
    });
  }

  function dispatchVariantUpdate(pickerRoot, variant, productId, sourceId, productHandle, controllerHolder) {
    const sectionWrapper = pickerRoot.closest('[id^="shopify-section-"]');
    const sectionId = sectionWrapper ? sectionWrapper.id.replace(/^shopify-section-/, '') : '';

    const productUrl = productHandle ? `/products/${encodeURIComponent(productHandle)}` : window.location.pathname;
    const fragmentParams = [`variant=${encodeURIComponent(variant.id)}`];
    if (sectionId) fragmentParams.push(`section_id=${encodeURIComponent(sectionId)}`);
    const fragmentUrl = `${productUrl}?${fragmentParams.join('&')}`;

    if (controllerHolder.current) {
      controllerHolder.current.abort();
    }
    const controller = new AbortController();
    controllerHolder.current = controller;
    const selectionToken = controllerHolder.token;

    fetch(fragmentUrl, { signal: controller.signal })
      .then((response) => (response.ok ? response.text() : ''))
      .then((responseText) => {
        const html = responseText
          ? new DOMParser().parseFromString(responseText, 'text/html')
          : new DOMParser().parseFromString('', 'text/html');
        if (controllerHolder.token !== selectionToken) return;
        const event = new CustomEvent('variant:update', {
          bubbles: true,
          detail: {
            resource: variant,
            sourceId,
            data: {
              html,
              productId,
              newProduct: null,
            },
          },
        });
        pickerRoot.dispatchEvent(event);
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        console.warn('[divano-variant-adapter] section fetch failed:', err);
        if (controllerHolder.token !== selectionToken) return;
        const event = new CustomEvent('variant:update', {
          bubbles: true,
          detail: {
            resource: variant,
            sourceId,
            data: {
              html: new DOMParser().parseFromString('', 'text/html'),
              productId,
              newProduct: null,
            },
          },
        });
        pickerRoot.dispatchEvent(event);
      });
  }

  function cssEscape(s) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(s);
    }
    return String(s).replace(/[^a-zA-Z0-9_-]/g, (ch) => `\\${ch}`);
  }

  function wirePicker(pickerRoot) {
    const handle = pickerRoot.dataset.productHandle;
    let manifestScript =
      pickerRoot.nextElementSibling &&
      pickerRoot.nextElementSibling.matches &&
      pickerRoot.nextElementSibling.matches('script[type="application/json"][data-divano-variant-manifest]')
        ? pickerRoot.nextElementSibling
        : null;
    if (!manifestScript && handle) {
      manifestScript = document.querySelector(
        `script[type="application/json"][data-divano-variant-manifest][data-product-handle="${cssEscape(handle)}"]`
      );
    }
    const manifest = readVariantManifest(manifestScript);
    if (!manifest) {
      return;
    }

    const controllerHolder = { current: null, token: 0 };
    const productHandle = pickerRoot.dataset.productHandle || '';

    pickerRoot.addEventListener(SELECT_EVENT, () => {
      controllerHolder.token += 1;
      if (controllerHolder.current) {
        controllerHolder.current.abort();
        controllerHolder.current = null;
      }

      const tuple = readCurrentSelection(pickerRoot, manifest.optionNames);
      if (tuple.some((v) => !v)) return;

      const variant = resolveVariant(manifest.variants, tuple);
      if (!variant) {
        updateMasterFormInputs('', pickerRoot);
        setAddToCartUnavailable(pickerRoot, true);
        return;
      }

      const productId = pickerRoot.dataset.productId || '';
      if (variant.available !== false) {
        setAddToCartUnavailable(pickerRoot, false);
      }
      updateMasterFormInputs(variant.id, pickerRoot);
      dispatchVariantUpdate(
        pickerRoot,
        variant,
        productId,
        pickerRoot.id || 'divano-variant-picker',
        productHandle,
        controllerHolder
      );
    });
  }

  function init() {
    document.querySelectorAll('divano-variant-picker').forEach(wirePicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
